import { render, staticRenderFns } from "./policeContent.vue?vue&type=template&id=351eb9a7&"
import script from "./policeContent.vue?vue&type=script&lang=js&"
export * from "./policeContent.vue?vue&type=script&lang=js&"
import style0 from "./policeContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports